/**
 * ID
 * @param val
 * @returns {string|boolean}
 * @constructor
 */
export function ID(val) {
	if (!val || !val.length) {
		return 'יש להזין 9 ספרות של מספר ת.ז.'
	}

	val = val + ''
	if (val.length !== 9 || isNaN(val)) {
		return 'יש להזין 9 ספרות של מספר ת.ז.'
	}

	let sum = 0
	for (let i in val) {
		i = Number(val[i]) * ((i % 2) + 1)
		sum += i > 9 ? i - 9 : i
	}
	return sum % 10 === 0 || 'מספר ת.ז. לא תקין'
}

/**
 * Passport
 * @param val
 * @returns {string|boolean}
 */
export function passport(val) {

	val = val + ''
	if (val.length > 9) {
		return 'יש להזין עד 9 ספרות.'
	}

	return /^[0-9a-zA-Z]+$/.test(val) || 'יש להזין מספר דרכון תקין.';
}

/**
 * @param len
 * @param err
 * @returns {function(...[*]=)}
 */
export function minLength(len, err) {
	return val => {
		val = (val + '').trim()
		if (!val || !val.length || val.length < len) {
			return err
		} else {
			return true
		}
	}
}

/**
 * Used to validate select inputs against their array of values
 * @param arr
 * @param field_name
 * @returns {function(...[*]=)}
 */
export function select(arr, field_name) {
	return val => {
		if (arr.indexOf(val) < 0) {
			return 'יש לבחור ערך עבור ' + field_name
		} else {
			return true
		}
	}
}

const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

/**
 * Validate email string
 */
export function email(v) {
	return !v.length || EMAIL_RE.test(v) || 'כתובת המייל אינה תקינה'
}

/**
 * Validate email required string
 */
export function emailRequired(v) {
	return (v.length && EMAIL_RE.test(v)) || 'כתובת המייל אינה תקינה'
}

/**
 * Min value validation
 * @param min_val
 * @param field_name
 * @returns {function(*): boolean|string}
 */
export function minVal(min_val, field_name) {
	return v => {
		return (
			+v > min_val || 'יש להזין ערך גבוה מ- ' + min_val + ' עבור ' + field_name
		)
	}
}

/**
 * General file validation
 * @param field_name
 * @param required
 * @param max_size - in MB
 * @param types
 * @returns array
 */
export function generalFile(
	field_name,
	required = true,
	max_size = 5,
	types = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx']
) {
	return [
		v => !required || (!!v && !(v instanceof Array && v.length === 0)) || 'יש לבחור קובץ עבור ' + field_name,

		v => {
			if (!required && ((v instanceof Array && v.length === 0) || !v)) return true;

			if (v instanceof Array) {
				return v.reduce((acc, item) => {
					return typeof acc === 'string'
						? acc
						: item.size < max_size * 1000000 ||
						field_name + ' יכול להכיל קבצים עד ' + max_size + 'MB'
				}, true)
			} else {
				return (
					(!!v && v.size < max_size * 1000000) ||
					field_name + ' יכול להכיל קובץ עד ' + max_size + 'MB'
				)
			}
		},

		v => {
			if (!required && ((v instanceof Array && v.length === 0) || !v)) return true;

			if (v instanceof Array) {
				return v.reduce((acc, item) => {
					let ext = (item.name.split('.').pop() + '').toLowerCase()
					return typeof acc === 'string'
						? acc
						: types.indexOf(ext) > -1 ||
						field_name + ' יכול להיות מהסוגים: ' + types.join(', ')
				}, true)
			} else {
				if (v && 'name' in v) {
					let ext = (v.name.split('.').pop() + '').toLowerCase()
					return (
						types.indexOf(ext) > -1 ||
						field_name + ' יכול להיות מהסוגים: ' + types.join(', ')
					)
				}
				return true
			}
		}
	]
}

/**
 * Vuetify required rule.
 * @param value
 */
export const requiredRule = value => {
	return !!value || 'שדה חובה'
}

/**
 * Tel number verify
 */
export const tel = v => (!v.length || v.replace(/[^0-9]+/g, '').length > 6 || 'יש להזין מספר טלפון תקין');

/**
 * ZIPCODE verify
 */
export const zip = v => (!v.length || v.replace(/[^0-9]+/g, '').length > 3 || 'יש להזין מיקוד תקין');

/**
 * only numbers
 */
export const numbers = v => (typeof +v === 'number' && !isNaN(+v)) || 'יש להזין מספרים בלבד';
